<template>
<div class="chapter">
<div class="inner_page">
<div id="th">
<div class="generated-style">
<p class="img" style="padding:0em; margin:0em;"><img alt="" src="images/per-003.jpg" style="height:100%;"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LO-04.vue?72537bb9